import React from 'react';
import type {CompareEntitiesFormsProps} from '../types';
import {Spacer} from '../../../components';
import {CompareEntitiesActions} from './CompareEntitiesActions';
import {CompareEntitiesForms} from './CompareEntitiesForms';

export const CompareEntitiesCore: React.FC<
  CompareEntitiesFormsProps
> = props => {
  return (
    <>
      <CompareEntitiesActions />
      <Spacer height={2} />
      <CompareEntitiesForms {...props} />
    </>
  );
};
